var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsDocumentManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33341 8.66666H10.6667V7.33333H5.33341V8.66666ZM5.33341 10.6667H10.6667V9.33333H5.33341V10.6667ZM5.33341 12.6667H8.66675V11.3333H5.33341V12.6667ZM4.00008 14.6667C3.63341 14.6667 3.31953 14.5361 3.05841 14.275C2.7973 14.0139 2.66675 13.7 2.66675 13.3333V2.66666C2.66675 2.29999 2.7973 1.98611 3.05841 1.72499C3.31953 1.46388 3.63341 1.33333 4.00008 1.33333H9.33342L13.3334 5.33333V13.3333C13.3334 13.7 13.2029 14.0139 12.9417 14.275C12.6806 14.5361 12.3667 14.6667 12.0001 14.6667H4.00008ZM8.66675 5.99999V2.66666H4.00008V13.3333H12.0001V5.99999H8.66675Z",
    fill: "#4C5E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsDocumentManagement);
export default __webpack_public_path__ + "static/media/icons-document-management.e402b39b.svg";
export { ForwardRef as ReactComponent };